import * as yup from 'yup';

/**
 * RQ-11 — sign in with a handle OR an email address.
 *
 * The field is called `identifier`, not `username`. That is not cosmetic: while
 * it was called `username`, both this schema and the product CRM's validator
 * carried an `.email()` rule on it — which read as reasonable given the name,
 * and rejected every valid handle before the request was ever sent.
 *
 * Deliberately NOT re-validating the shape. The server decides which namespace
 * an identifier belongs to (an `@` means email, no `@` means handle), and a
 * client-side rule that disagrees can only ever block a login the server would
 * have accepted. Presence is the client's business; correctness is the
 * server's.
 */
export const loginSchema = yup.object({
	identifier: yup
		.string()
		.trim()
		.required('Enter your username or email'),
	password: yup.string().required('Password Is required'),
});
